<template>
  <div>
    <loading v-show="showLoader" />
    <!-- banner area -->
    <div class="container-fluid ib-header-bg">
      <div class="row">
        <div class="col-12 px-0 px-sm-1">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div class="container ib-pl-0">
                  <div class="row wow animate__animated animate__fadeInRight">
                    <div class="col-md-6 position-relative">
                      <h1 class="pt-4 pt-lg-5 pb-sm-3 pb-md-4 pb-lg-5 mt-5 ib-hero-text" style="margin-bottom:0px">
                        <!-- <span style="color:#3d9cbd;">Customer</span><br>
                        <span style="text-transform: uppercase; font-family: 'Avenir Medium'; font-weight: 900 !important;">Complaint Portal</span><br> -->
                        <span style="color:#3d9cbd;">Ghar Baithay</span><br>
                        <span style="text-transform: uppercase; font-family: 'Avenir Medium'; font-weight: 900 !important;">Sm<span>a</span>rt Insur<span>a</span>nce</span><br>
                        <span style="color:#3d9cbd;">Sab
                          Kay Liye</span>
                      </h1>
                      <img alt="Logo Icon" class="img-fluid in-shield-position border_img" :src="require('@/assets/images/bg/shield-for-banner.svg')" />
                    </div>
                  </div>
                <!--  <div class="row class-row-mx ib-pl-0">-->
                  <!-------------------------------------------------------->

                            <div class="row">
                              <div class="col-md-7 col-lg-7" style="padding-left:0px !important;">
                                <div class="d2c-class-container main_btn mb-1 px-2 " style="padding-left:0px !important">
                                  <ul class="nav nav-tabs ib-nav-tabs mx-auto ml-md-0" style="width:100%;flex-wrap: nowrap">
                                    <li class="nav-item">
                                      <a role="button" :class="classType == 0 ? 'active' : ''" @click="filterClasses(0)" class="nav-link class-box in-horizontal-box cursor-pointer" content="Conventional" v-tippy>
                                        <img alt="icon" :src="require('@/assets/images/Conventional.svg')"/>
                                        <h4 class="class-name class-buy">Conventional</h4>
                                      </a>
                                    </li>
                                    <li class="nav-item">
                                      <a role="button" :class="classType == 1 ? 'active' : ''" @click="filterClasses(1)" class="nav-link class-box in-horizontal-box" content="Takaful" v-tippy>
                                        <img alt="icon" :src="require('@/assets/images/Takaful (1).svg')"/>
                                        <h4 class="class-name class-buy">Takaful</h4>
                                      </a>
                                    </li>
                                  </ul>
                                  </div>
                                  <div>
                                  <img style="width:80%;margin-left:3%;" class="border_img" alt="icon" :src="require('@/assets/images/bg/line-for-banner.svg')"/>
                                  </div>
                              </div>
                            </div>

                 <div class="row class-row-mx ib-pl-0">
                    <div class="col-12 ib-pl-0">
                      <div class="d-none d-md-block">
                        <!-- <img style="margin-top:10px" alt="icon" :src="require('@/assets/images/bg/Group 84503.svg')"/> -->
                        <div  v-for="mainClasses in chunkedData(filterdMainClasses)" class="d2c-class-container d2c_class1 wow animate__animated animate__fadeInUp">
                          <div v-for="mainClass in mainClasses">
                            <router-link :to="{ name: 'Acquisition', params: { classId: mainClass.id }}" class="class-box">
                              <div class="class-icon">
                                <img class="img-fluid" alt="Class Icon" :src="mainClass.logo"/>
                              </div>
                              <h4 class="class-name">{{ mainClass.name }}</h4>
                            </router-link>
                          </div>
                        </div>

                      </div>
                      <div class="d-md-none d2c-class-container d2c_class1 wow animate__animated animate__fadeInUp">
                        <!-- <img style="margin-top:10px" alt="icon" :src="require('@/assets/images/bg/Group 84503.svg')"/> -->
                        <div v-for="mainClass in mainClasses">
                          <router-link :to="{ name: 'Acquisition', params: { classId: mainClass.id }}" class="class-box">
                            <div class="class-icon">
                              <img class="img-fluid" alt="Class Icon" :src="mainClass.logo"/>
                            </div>
                            <h4 class="class-name">{{ mainClass.name }}</h4>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import loading from "@/components/Loading/Loading";

  export default {
    name: "Banner",
    data() {
      return {
        showLoader: false,
        mainClasses: {},
        filterdMainClasses: {},
        classType: 0
      };
    },
    components: {
      loading,
    },
    created() {
      const self = this;
      self.showLoader = true;
      self.getMainClasses();
    },
    methods: {
      filterClasses: function(type){
        const self = this;
        self.classType = type;
        if (type == 0){
          self.filterdMainClasses = self.mainClasses.filter(x => x.is_takaful == 0);
        }else{
          self.filterdMainClasses = self.mainClasses.filter(x => x.is_takaful == 1);
        }
      },
      chunkedData(data) {
        const self = this;
        return _.chunk(data, 4);
      },
      async getMainClasses() {
        const self = this;
        await axios
          .get("get_mainclasses")
          .then(function (resp) {
            self.showLoader = false;
            if (resp.data.code == 200) {
              self.mainClasses = resp.data.data.main_classes;
              self.filterClasses(0);
            } else {
              $toast.error(resp.data.message, { position: "top-right" });
              return false;
            }
          })
          .catch(function (error) {
            self.showLoader = false;
            error.response.data.errors.forEach((element) => {
              $toast.error(element.message, { position: "top-right" });
            });
          });
      },
    },
  };
</script>

<style scoped>
  @media (min-width: 48rem /* 768px */) {
    .d2c-class-container:nth-of-type(2) {
      margin-left: 3.75rem /* 60px */ !important;
    }
  }
  @media (max-width:34.375rem /* 550px */) {
    .ib-header-bg {
      background: url(~@/assets/images/bg/header-image-for-mobile.svg);
      background-repeat: no-repeat;
      background-repeat: no-repeat;
      background-position: 40% 0%;
      background-size: 110%;
      min-height: 100vh !important;
    }
    .d2c-class-container {
      justify-content: center !important;
      margin-top: 10.5rem !important;
    }
  }
  @media (min-width:34.4375rem /* 551px */) {
    .in-text-bottom {
      border-bottom: dashed 0.125rem /* 2px */ #c7c7c7;
    }
  }
  .class-icon {
    width:2.5rem; /* 40px */
    height:2.5rem; /* 40px */
    margin-top: 0.9375rem /* 15px */ !important;
  }
  .class-icon img {
    width: 100%;
    height: auto !important;
  }
  @media (min-width:34.375rem /* 550px */)c{
    .class-icon{
      width: 3.125rem /* 50px */ !important;
      height: 3.125rem /* 50px */ !important;
      margin-top: 0.9375rem /* 15px */ !important;
    }
    .class-icon imgc{
      width: 100%;
      height: auto !important;
    }
  }
  @media only screen and (-webkit-min-device-pixel-ratio: 3) {
  .class-icon{
    width:2.5rem /* 40px */ !important;
    height:2.5rem /* 40px */ !important;
    margin-top: 0.9375rem /* 15px */ !important;
  }
  .class-icon img {
    width: 100% !important;
    height: auto !important;
    }
  }
  /* Portrait and Landscape */
  @media only screen
    and (min-device-width: 25.875rem /* 414px */)
    and (max-device-width: 46rem /* 736px */)
    and (-webkit-min-device-pixel-ratio: 3) {
      .class-icon {
      width:2.5rem /* 40px */ !important;
      height:2.5rem /* 40px */ !important;
      margin-top: 0.9375rem /* 15px */ !important;
    }
    .class-icon img {
      width: 100% !important;
      height: auto !important;
    }
  }
  @media only screen
    and (device-width: 25.875rem /* 414px */)
    and (device-height: 56rem /* 896px */)
    and (-webkit-device-pixel-ratio: 3) {
    .class-icon {
      width:2.5rem /* 40px */ !important;
      height:2.5rem /* 40px */ !important;
      margin-top: 0.9375rem /* 15px */ !important;
    }
    .class-icon img {
      width: 100% !important;
      height: auto !important;
    }
  }
  .in-shield-position {
    position: absolute;
    bottom: 63px;
    left: -29px;
    max-width: 65px;
  }
  .d_block{
    display: inline-block !important;
  }
  .border_bottom{
     border-bottom:0.125rem /* 2px */ dashed rgb(234, 242, 247) !important;
     width:30%;
    }

  @media (max-width:550px){
  .d2c_class1{
    margin-top: 1rem !important;
  }
}
 @media (min-width:440px) and (max-width:549px){
  .main_btn{
    margin-top: 14rem !important;
  }
}
 @media(max-width:550px){
  div.main_btn > ul{
        flex-direction: column !important;
  }
  div.main_btn > ul > li{
     width: 70% !important;
    margin-left: auto;
    margin-right: auto;
  }
  div.main_btn > ul > li > a{
    width: 100% !important;
        flex-direction:row !important;
        height:65px !important;
  }
    div.main_btn > ul > li > a > img{
    margin-top: 0px !important;
  }
   div.main_btn > ul > li > a.active > img{
    margin-top: 0px !important;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Home/Banner.vue